<template>
  <modal
    size="extrasmall"
    class="ModalCampaign"
    @close="close"
    :hasFooter="false"
  >
    <div slot="content" v-if="campaign">
      <div class="ModalCampaign__content Content">
        <p
          v-if="campaign.title && !(campaign.titleNonSubscriber && !assinante)"
          class="ModalCampaign__title"
        >
          {{ campaign.title }}
        </p>
        <p
          v-if="campaign.titleNonSubscriber && !assinante"
          class="ModalCampaign__title"
        >
          {{ campaign.titleNonSubscriber }}
        </p>
        <div>
          <slot name="content">
            <template
              v-if="
                user &&
                  campaign &&
                  (campaign.subscriber || campaign.nonSubscriber)
              "
            >
              <p v-if="aguardandoPagamento" class="ModalCampaign__sub">
                Sabemos que você solicitou um novo plano, mas o pagamento ainda
                não foi confirmado
              </p>
              <p v-else-if="assinante" class="ModalCampaign__sub">
                {{ campaign.subscriber || "" }}
              </p>
              <p v-else class="ModalCampaign__sub">
                {{ campaign.nonSubscriber || "" }}
              </p>
              <div class="ModalCampaign__icon">
                <icon
                  :name="campaign.icon ? campaign.icon : icon"
                  size="giant"
                  class="-left -default ModalCampaign__icon"
                ></icon>
              </div>
              <p v-if="aguardandoPagamento" class="ModalCampaign__footer">
                Estamos aguardando a confirmação de pagamento e em breve esta
                opção estará liberada.
              </p>
              <p class="ModalCampaign__footer" v-else-if="lowerPrice">
                {{
                  campaign.footer ? campaign.footer : "Faça mais a partir de"
                }}
                <span class="price"
                  >{{ lowerPrice }}<span class="price-period">/mês</span></span
                >
              </p>
              <p v-else class="ModalCampaign__footer">
                Entre em contato e personalize seu plano
              </p>
            </template>
            <button
              v-if="aguardandoPagamento && boleto"
              class="button btn ModalCampaign__btn -secondary"
              block
              @click="goToBoleto"
            >
              Imprimir boleto
            </button>
            <button
              v-else-if="
                user && user.dados_assinatura && user.dados_assinatura.assinante
              "
              class="button btn ModalCampaign__btn -secondary"
              block
              @click="goToChangePlan"
            >
              Alterar meu plano
            </button>
            <button
              v-else-if="logged"
              block
              class="button btn ModalCampaign__btn -secondary"
              @click="goToPlans"
            >
              Ver planos disponíveis
            </button>
            <button
              v-else-if="!logged"
              block
              class="button btn ModalCampaign__btn -secondary"
              @click="goToNewAccount"
            >
              Criar conta
            </button>
          </slot>
        </div>
      </div>
    </div>
  </modal>
</template>

<script>
import Modal from "../monitoramentos/Modal.vue";
const currentPlanService = "iugu";
import { subdomainUrl } from "../../utils/url";
import { currency } from "../../filters/index";

export default {
  components: {
    Modal
  },
  props: {
    title: {
      default: "Disponível apenas para assinantes",
      type: String
    },
    campaign: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  data() {
    return {
      lowerPrice: null
    };
  },
  computed: {
    icon() {
      return this.aguardandoPagamento ? "lock" : "trending-up";
    },
    user() {
      return this.$store.state.usuario.user;
    },
    plans() {
      return this.$store.state.planos;
    },
    assinante() {
      return (
        this.user &&
        this.user.dados_assinatura &&
        this.user.dados_assinatura.assinante
      );
    },
    logged() {
      return this.user && this.user.id;
    },
    aguardandoPagamento() {
      return (
        this.assinante &&
        !this.user.dados_assinatura.tem_premium &&
        !this.user.dados_assinatura.esta_suspensa
      );
    },
    boleto() {
      if (
        this.$store.state.usuario &&
        this.$store.state.usuario.invoices &&
        this.$store.state.usuario.invoices.items &&
        this.$store.state.usuario.invoices.items.length
      ) {
        return this.$store.state.usuario.invoices.items[0];
      }
      return null;
    }
  },
  mounted() {
    let plans = this.plans.slice(0);
    let lowerPriceService = null;

    plans = plans.filter(plan => {
      if (
        plan.services &&
        plan.services.length &&
        (!this.assinante || plan.nome !== this.user.dados_assinatura.detalhes_plano.nome)
      ) {
        if (!this.campaign.planKey) {
          return plan.services.length;
        } else if (this.logged && this.assinante) {
          if (
            this.user.dados_assinatura.detalhes_plano &&
            this.user.dados_assinatura.detalhes_plano[this.campaign.planKey] ===
            null
          ) {
            return plan[this.campaign.planKey] === null
          }

          return (
            this.user.dados_assinatura.detalhes_plano &&
            this.user.dados_assinatura.detalhes_plano[this.campaign.planKey] !==
              undefined &&
            this.user.dados_assinatura.detalhes_plano[this.campaign.planKey] <
              plan[this.campaign.planKey]
          );
        } else {
          return (
            plan[this.campaign.planKey] === 'SIM' ||
            plan[this.campaign.planKey] > 0 ||
            plan[this.campaign.planKey] === null
          );
        }
      }
    });

    plans.forEach(plan => {
      const services = plan.services.filter(
        s => s.service === currentPlanService
      );
      services.forEach(service => {
        if (!lowerPriceService || service.preco < lowerPriceService.preco) {
          lowerPriceService = service;
        }
      });
    });

    if (lowerPriceService) {
      let lowerPrice = lowerPriceService.preco / 100;
      if (
        lowerPriceService.intervaloPagamento === 6 &&
        lowerPriceService.tipoIntervalo === "MES"
      ) {
        lowerPrice = lowerPrice / 6;
      }
      if (typeof currency === "function") {
        this.lowerPrice = currency(lowerPrice, "R$", 2, ",", ".");
      }
    }
  },
  methods: {
    close() {
      this.$emit("close");
    },
    save() {
      this.$emit("save");
    },
    goToBoleto() {
      window.open(this.boleto.link_externo);
      this.close();
    },
    goToNewAccount() {
      window.location.href = subdomainUrl(
        "www",
        `/cadastrar?auth.redirect=${window.location.href}`
      );
    },
    goToPlans() {
      const complement = this.campaign.id
        ? `?campaign_id=${this.campaign.id}`
        : "";
      window.location.href = subdomainUrl("www", `/precos${complement}`);
    },
    goToChangePlan() {
      const complement = this.campaign.id
        ? `?campaign_id=${this.campaign.id}`
        : "";
      window.location.href = subdomainUrl(
        "www",
        `configuracoes/assinatura/alterar-plano${complement}`
      );
    }
  }
};
</script>

<style lang="stylus">
.ModalCampaign
  text-align center
  font-weight 400
  &__title
    text-align center
    font-size 22px
    font-weight 600
    color #424242
  &__footer
    margin-top 0rem
    margin-bottom 2rem
  &__btn
    width 100%
    &.-secondary
      background-color #dc6c51
      color #FFF
      border-color #dc6c51
      &:hover, &:focus
        background-color #d85a3c
        border-color #d85a3c
  &__icon
    fill rgb(220, 108, 80)
  &__content
    text-align center
    max-width 768px
  &__sub
    margin-top 1rem
    color rgba(72, 72, 72, 0.8)
  &__icon
    display flex
    justify-content center
    margin 16px 0
    & > svg
      color rgb(74, 74, 74)
.price
  display block
  font-weight 700
  font-size 20px
</style>

<style lang="stylus">
.bar-options .btn.-medium
  padding 9px 24px
  margin-right 0
</style>
